<template>
	<div class="home">
		<HeaderBar :title="title" :leftArrow="true" url="/main/service/service400/patient/list"></HeaderBar>
		<div class="center-box-no-footer">
			<div class="patient-card-box">
				<div class="patient-card-content">
					<div class="content-title">
						<div class="custom-title">姓名缩写：{{ form.bq001002 }} 【{{ form.bq001018 }}】</div>
						<!-- <div class="custom-title" style="margin-top: 1rem;">筛选编号：</div> -->
					</div>
					<div class="content-info" style="margin-top: 1rem;">
						<!-- <div class="patient-status">治疗组</div> -->
						<div class="patient-info-item" style="font-size: 0.9rem;">治疗日期：{{ form.bq001040.substring(0, 10)
							}} 【{{ form.extend3 }}岁】</div>
						<div class="patient-info-item" style="font-size: 0.9rem;"></div>
						<div class="patient-info-item" style="font-size: 0.9rem;"></div>
					</div>
					<div class="content-info" v-show="false">
						<div class="patient-info-item">项目医生：{{ config.usertype.find(item => item.id ==
			form.bq001041).text
							}}
						</div>
						<div class="patient-info-item" style="margin-bottom: 0.5rem;">
							校核：{{ config.usertype.find(item => item.id == lastFollow.bq400998).text }}</div>
					</div>
					<embed class="patient-icon" :src="patientIcon" type="image/svg+xml"
						pluginspage="http://www.adobe.com/svg/viewer/install/" />

				</div>
			</div>
			<div class="patient-record-box">
				<!-- <div class="record-title" 
					style="font-size: 1rem;margin-top: 1rem; font-weight: 600;color: #666;">HCV治疗情况</div> -->
				<div>
					<van-divider style="color: black; font-weight: 600;font-size: 1rem;">基线（治疗前）</van-divider>
					<van-row style="background-color: #fff;">
						<van-col span="18">
							<FormNormalInput label="HCV基因型" v-model="bq418List[0].Bq418_003" readonly />
						</van-col>
						<van-col span="6" class="unit">型</van-col>
					</van-row>
					<van-row style="background-color: #fff;">
						<van-col span="18">
							<FormNormalInput label="HCV RNA" v-model="bq418List[0].Bq418_002" readonly />
						</van-col>
						<van-col span="6" class="unit">IU/mL</van-col>
					</van-row>

				</div>
				<div>
					<van-divider style="color: black; font-weight: 600;font-size: 1rem;">治疗方案</van-divider>
					<FormNormalInput label="方案" v-model="bq418List[0].Bq421_002" readonly />
					<FormNormalInput label="内容" v-model="bq418List[0].Bq421_004" readonly v-show="bq418List[0].Bq421_002=='其他'" />
					<div style="margin-left: 1rem; color:red; " v-show="false">※ 对停药后12周时无可用数据的患者，收集其后最近一次的可获得数据。</div>
				</div>
				<div>
					<van-divider style="color: black; font-weight: 600;font-size: 1rem;">治疗12周结束时（±7天）</van-divider>
					<van-row style="background-color: #fff;">
						<van-col span="18">
							<FormNormalInput label="HCV RNA" v-model="bq418List[1].Bq418_002" readonly />
						</van-col>
						<van-col span="6" class="unit">IU/mL</van-col>
					</van-row>
				</div>
				<div>
					<van-divider style="color: black; font-weight: 600;font-size: 1rem;">{{ follow2Name}}</van-divider>
					<van-row style="background-color: #fff;">
						<van-col span="18">
							<FormNormalInput label="HCV RNA" v-model="bq418List[2].Bq418_002" readonly />
						</van-col>
						<van-col span="6" class="unit">IU/mL</van-col>
					</van-row>
				</div>
			</div>
			<div class="patient-record-box">
				<div class="record-title" v-show="recordList.length > 0"
					style="font-size: 1.1rem;margin-top: 2rem; font-weight: 600;color: #666;">随访记录列表</div>
				<div class="record-item" v-for="item in recordList" :key="item.guid" style="margin-top: 1rem;">
					<van-cell-group>
						<van-cell center>
							<template #title>
								<!-- <div class="record-time">{{item.bq400995.substring(0,10)}}</div> -->
							</template>
							<template #label>
								<div class="record-info-item">
									<div class="record-info-text custom-title"
										style="width: 15.2rem; font-size: 1rem;font-weight: 600;">{{ item.bs025003 }}
									</div>
									<!-- <div class="record-info-type">随访名称</div> -->
								</div>
								<div class="record-info-item">
									<div class="record-info-text custom-title" v-if="item.bq400996 == '0'"
										style="color:#909399;">数据填写中</div>
									<div class="record-info-text custom-title" v-if="item.bq400996 == '1'"
										style="color:#909399;">数据校验中</div>
									<div class="record-info-text custom-title" v-if="item.bq400996 == '2'"
										style="color:#f56c6c;">数据异常待修复</div>
									<div class="record-info-text custom-title" v-if="item.bq400996 == '3'"
										style="color:#909399;">随访完成</div>
									<!-- <div class="record-info-text custom-title">9个月</div> -->
									<div class="record-info-type">

									</div>
								</div>
							</template>
						</van-cell>
						<div class="list-cell-footer"
							style="margin:1rem; display:flex; justify-content: space-between;">
							<van-button plain hairline type="success" icon="edit" @click="Record(item)" v-if="item.Bq400_996==0">填写随访数据
							</van-button>&nbsp;
							<van-button plain hairline type="success" icon="eye-o" @click="Record(item)" v-else>查看随访数据
							</van-button>&nbsp;
							<van-button icon="upgrade" plain hairline type="success" @click="statusSave(item)"
								v-if="item.bq400996 == '0' || item.bq400996 == '2'">提交后台校验
							</van-button>
						</div>
					</van-cell-group>

				</div>

				<div class="record-title" v-show="Bq422List.length > 0"
					style="font-size: 1.3rem;margin-top: 2rem; font-weight: 600;color:#58be6a;">不良事件记录</div>
				<div class="record-item" @click="RecordBq422(item)" v-for="item in Bq422List" :key="item.guid">
					<van-cell-group>
						<van-cell center is-link>
							<template #title>
								<!-- <div class="record-time">添加时间：{{ item.addTime ? item.addTime.substring(0, 10) : '' }}
								</div> -->
							</template>
							<template #label>
								<div class="record-info-item" style="padding-top: 0;">
									<div class="record-info-text custom-title"
										style="width: 12rem; font-size: 1.1rem;font-weight: 600;">{{ item.Bq422_002 }}
									</div>
									<!-- <div class="record-info-type">随访名称</div> -->
								</div>
								<div class="record-info-item" style="padding-top: 0;">
									<div class="record-info-text custom-title">{{ item.Bq422_003 }} {{ item.Bq422_007 }}
										周
									</div>
									<!-- <div class="record-info-type">不良事件数：3</div>								 -->
								</div>
							</template>
						</van-cell>
					</van-cell-group>
				</div>
			</div>
		</div>

		<div class="patient-bottom-box" v-show="false">
			<div class="patient-button-box">
				<van-button type="info" @click="AddRandomRecord">新增随访记录</van-button>
				<van-button type="primary" @click="Add422Data">新增不良事件</van-button>
			</div>
		</div>
		<van-action-sheet v-model="showRecordSet" title="设置">
			<recordSetSelect v-if="showRecordSet" :patientModel="form" :recordSetType="recordSetType"
				:recordSetList="recordSetList" :userType="lastFollow.bq400998" @closeAction="closeSetting">
			</recordSetSelect>
		</van-action-sheet>

		<van-popup v-model="showPopup" closeable position="right" :style="{ width: '100%', 'height': '100%' }"
			@close="loadBQ418">
			<div class="setting-right-content">
				<followRecordIndex v-if="showPopup"></followRecordIndex>
			</div>
		</van-popup>

		<van-popup v-model="add422Popup" closeable position="right" :style="{ width: '100%', 'height': '100%' }"
			@close="loadBq422">
			<div class="setting-right-content">
				<bq422DataAdd v-if="add422Popup" :bq001008="form.bq001018"></bq422DataAdd>
			</div>
		</van-popup>

		<van-popup v-model="show422Popup" closeable position="right" :style="{ width: '100%', 'height': '100%' }">
			<div class="setting-right-content">
				<bq422DataShow v-if="show422Popup" :guid="bq422guid" :closePage="closePage"></bq422DataShow>
			</div>
		</van-popup>
		<van-dialog v-model="showSubmitDialog" title="" show-cancel-button :before-close="beforeSubmit">
			<van-form :model="submitModel">
				<FormNormalInput v-model="submitModel.Bq400record_Remark" label="提交说明" v-show="false"></FormNormalInput>
				<van-row style="margin-left: 6rem;margin-top: 2rem;margin-bottom: 2rem;">是否确认提交？</van-row>
			</van-form>
		</van-dialog>
		<van-dialog v-model="showChangeFollowName" title="设置随访时间" show-cancel-button @confirm="saveFollowName" :before-close="beforeconfirm">
			<div style="height: 100%;">
				<!-- <StaticSingleSelect label="时间" :selectkey.sync="submitFollowNameModel.Bs025_003" :list="followName"
							required />		 -->
				<van-radio-group v-model="submitFollowNameModel.Bs025_003">
					<van-cell-group inset>
						<van-cell title="停药后12周（±14天）" clickable
							@click="submitFollowNameModel.Bs025_003 = '停药后12周（±14天）'">
							<template #right-icon>
								<van-radio name="停药后12周（±14天）" />
							</template>
						</van-cell>
						<van-cell title="停药后12+周（±14天）" clickable
							@click="submitFollowNameModel.Bs025_003 = '停药后12+周（±14天）'">
							<template #right-icon>
								<van-radio name="停药后12+周（±14天）" />
							</template>
						</van-cell>
					</van-cell-group>
					<van-row v-show="submitFollowNameModel.Bs025_003=='停药后12+周（±14天）'">
						<FormNormalInput label="具体周" v-model="submitFollowNameModel.week" />
					</van-row>
				</van-radio-group>
			</div>
		</van-dialog>
	</div>
</template>

<script>
import componentsModel from '../base/components.js'
import followRecordIndex from '../followRecord/index.vue'
import bq422DataAdd from '../bq422/form.vue'
import bq422DataShow from '../bq422/detail.vue'
export default {
	name: 's400PatientDetail',
	data() {
		return {
			title: '患者信息',
			searchValue: "",
			// 背景图片
			patientIcon: require("../../../../assets/image/patient-icon.svg"),
			config: JSON.parse(sessionStorage.getItem("config")),
			form: {
				id: "",
			},
			showChangeFollowName: false,
			submitFollowNameModel: {
				guid: "",
				Bs025_003: "停药后12周（±14天）",
				week: "",
			},
			followName: [{ id: "停药后12周", name: "停药后12周" }, { id: "停药后12+周", name: "停药后12+周" }],
			recordList: [],
			loading: false,
			// 新增随访记录pop
			showRecordSet: false,
			// 新增随访类型 1-标准随访，2-不定期随访
			recordSetType: "1",
			// 随访可选数组
			recordSetList: [],
			// 随访记录pop
			showPopup: false,
			//不良事件
			add422Popup: false,
			show422Popup: false,
			bq422guid: '',
			lastFollow: {
				bq400998: 1
			},
			Bq422List: [],
			showSubmitDialog: false,

			// 提交数据
			submitModel: {
				id: "0", //编号
				guid: "", //guid编号
				companyGuid: "", //单位编号
				departmentGuid: "", //部门编号
				checkStatus: "", //审核状态
				dataStatus: "", //数据状态
				addUid: "", //添加人编号
				addTime: "", //添加时间
				bq400recordRemark: "", //修改说明
				bq400996: "", //当前修改状态
				bq4009962: "", //当前状态名称
				bq400guid: "", //随访编号
				addUserName: "", //修改人姓名
				Bq400record_Remark: '', //修改说明
				Bq400_996: '', //当前修改状态
				Bq400_996_2: '', //当前状态名称
				Bq400_guid: '', //随访编号
			},
			searchBq018Url: this.$utils.Url.s400 + '/api/S400Bq418/ListByBQ001018',
			bq418List: [],
			follow2Name:'停药后12周或12+周（±14天）'

		}

	},
	// 页面渲染，初始化form的数据
	created() {
		this.form = this.$route.params
		console.log(this.form)
	},
	components: {
		followRecordIndex,
		bq422DataAdd,
		bq422DataShow,
		...componentsModel
	},
	methods: {
		onSearch() {

		},
		// 记录页面
		Record(item) {
			sessionStorage.setItem('bq400', JSON.stringify(item))
			if (item.bq400999 == 2 && item.Bs025_003 == '停药后12周或12+周（±14天）') {
				//修改名称
				this.submitFollowNameModel.guid = item.guid
				this.showChangeFollowName = true
			} else {
				this.showPopup = true
			}
		},
		// 新增标准随访 , 类型为1
		AddNormalRecord() {
			let that = this
			that.recordSetType = "1"
			that.showRecordSet = true
		},
		// 新增不定期随访, 类型为2
		AddRandomRecord() {
			let that = this
			that.recordSetType = "2"
			that.showRecordSet = true
		},
		// 新增随访完成事件
		closeSetting(model) {
			let that = this
			that.recordList.push(model)
			that.showRecordSet = false
			// 调用查看随访详情接口
			that.Record(model)
		},
		//获取随访列表
		loadinfo: function () {
			let that = this
			var condition = {
				bq001018: this.form.bq001018,
				patuid: this.form.uid,
				currentPage: 1,
				pageSize: 9999,
				recordCount: 0,
				menuid: '6c8e601a-2f7b-4868-8dd1-aacfa2d8a38b'
			}
			that.$utils.HttpPost(that.$utils.Url.s400 + '/api/S400Bq400/ListByUid', condition, function (d) {
				let dataList = []
				d.data.forEach((item) => {
					that.$utils.CopyKeyInfo(item, item)
					if(item.bq400999==2){
						that.follow2Name = item.Bs025_003
					}
					dataList.push(item)
				})
				// 已选中的随访类型数组
				let typeSelectedList = dataList.map(item => item.bs025003)
				// 获得当前操作所有的类型数组
				let allSetList = that.config.usertype.find(item => item.id == that.form.bq001041).date
				// 获得还未进行的标准随访数据
				that.recordSetList = allSetList.filter(m => typeSelectedList.indexOf(m + "随访") == -1)
				that.recordList = dataList
				that.loading = false
				// that.autoLoadFollow()
			}, null, null, null)
		},
		loadLastFollow: function () {
			let that = this
			var args = {
				bq001018: this.form.bq001018
			}
			that.$utils.HttpPost(this.$utils.Url.s400 + '/api/S400Bq400/LastFollow', args, function (
				d) {
				that.lastFollow = d.data
				that.$utils.CopyKeyInfo(that.lastFollow, that.lastFollow)
			}, null, null, null)
		},

		loadBQ418: function () {
			let that = this
			var args = {
				bq001018: this.form.bq001018
			}
			that.$utils.HttpPost(this.searchBq018Url, args, function (
				d) {
				that.bq418List = d.data
			}, null, null, null)
		},
		autoLoadFollow: function () {
			//找到最后一次标准随访，调用方法，显示时间轴
			var followlist = this.recordList.filter(item => {
				return item.bq400999 < 2
			})
			if (followlist) {
				this.clickFollowItem(followlist[followlist.length - 1])
			}
		},
		//保存状态
		statusSave: function (row) {
			let that = this

			that.submitModel.Bq400_guid = row.guid
			that.submitModel.Bq400_996_2 = '提交校核'
			that.submitModel.Bq400_996 = 1
			that.submitModel.bq400recordRemark = ""
			that.showSubmitDialog = true
		},
		// 弹窗关闭事件之前，校验是否已经有值
		beforeSubmit: function (action, done) {
			let that = this
			
			if (action == "confirm") {
				that.$utils.HttpPost(that.$utils.Url.s400 + '/api/S400Bq400record/Save/', that.submitModel,
					function () {
						that.$dialog({
							message: "修改成功"
						})
						that.loadinfo()						
						done()
					}, null, null, null)
			} else {
				done()
			}
		},
		Add422Data: function () {
			this.add422Popup = true
		},
		loadBq422: function () {
			let that = this
			var args = {
				bq001018: this.form.bq001018,
				currentPage: 1,
				pageSize: 9999,
				recordCount: 0,
				menuid: '6c8e601a-2f7b-4868-8dd1-aacfa2d8a38b'
			}
			that.$utils.HttpPost(this.$utils.Url.s400 + '/api/S400Bq422/List', args, function (
				d) {
				that.Bq422List = d.data
			}, null, null, null)
		},
		RecordBq422: function (item) {
			this.bq422guid = item.guid
			this.show422Popup = true
		},
		closePage: function () {
			console.log('关闭')
			this.add422Popup = false
		},
		beforeconfirm:function(action, done){
			if (action == 'confirm') {
                done(false)
            } else {
                done(true)
            }
		},
		saveFollowName: function () {
			
			let that = this
			if(that.submitFollowNameModel.Bs025_003=='停药后12+周（±14天）' && that.submitFollowNameModel.week==''){
				that.$toast('请输入周数')
				return false
			}
			that.submitFollowNameModel.Bs025_003 = '停药后'+that.submitFollowNameModel.week+'周（±14天）'
			that.$utils.HttpPost(that.$utils.Url.s400 + '/api/S400Bq400/UpdateFollowName', that.submitFollowNameModel,
				function () {					
					that.showChangeFollowName = false
					that.showPopup = true
					that.loadinfo()
					
				}, null, null, null)
		}
	},
	mounted() {
		this.loadinfo()
		//this.loadLastFollow()
		//this.loadBq422()
		this.loadBQ418()
	}
}
</script>
<style scoped>
.center-box-no-footer {
	padding-bottom: 80px;
}

.patient-card-box {
	padding: 15px 1rem;
	width: 100%;
	box-sizing: border-box;
}

.patient-card-content {
	width: 100%;
	height: 120px;
	background-color: #fff;
	border-radius: 8px;
	padding: 20px;
	box-sizing: border-box;
	position: relative;
}

.patient-card-content .content-title span {
	padding-right: 10px;
}

.content-info {
	padding-top: 5px;
}

.content-info .patient-status {
	margin-right: 10px;
}

.patient-status {
	display: inline-block;
	height: 20px;
	width: 60px;
	line-height: 20px;
	text-align: center;
	font-size: 10px !important;
	color: #FF7B61;
	background: rgba(255, 123, 97, 0.06);
	border: 1px solid #FF7B61;
	border-radius: 4px;
	box-sizing: border-box;
}

.patient-detail .patient-status.active {
	background: rgba(64, 158, 255, 0.06);
	border: 1px solid #409EFF;
	color: #409EFF;
}

.patient-info-item {
	display: inline-block;
	height: 20px;
	line-height: 20px;
	padding: 0 10px;
	background: #F7F7F7;
	border-radius: 4px;
	font-size: 10px;
	color: #666666;
	text-align: center;
	margin-right: 10px;
}

.patient-icon {
	position: absolute;
	right: 0;
	bottom: 0;
	width: 83px;
	height: 87px;
}

.patient-record-box {
	padding-top: 5px;
	padding: 5px 1rem 0 1rem;
}

.patient-record-box .record-title {
	font-size: 14px;
	color: #666666;
	line-height: 14px;
	font-weight: 400;
	padding-bottom: 10px;
}

.record-item {
	padding-bottom: 10px;

}

.record-item .van-cell--center {
	border-radius: 9px;
	padding: 20px;
}

.record-item .record-time {
	font-size: 14px;
	color: #666666;
	line-height: 14px;
	font-weight: 400;
}

.record-item .van-cell__label {
	display: flex;
}

.record-info-item {
	flex: 1;
	display: inline-block;
	padding-top: 15px;
}

.record-info-type {
	font-size: 14px;
	color: #999999;
	line-height: 14px;
	font-weight: 400;
	padding-top: 10px;
}

.patient-bottom-box {
	width: 100%;
	height: 80px;
	padding: 0 1rem;
	box-sizing: border-box;
	position: fixed;
	bottom: 0;
}

.patient-bottom-box .patient-button-box {
	background-color: #fff;
	width: 100%;
	height: 100%;
	padding-bottom: 10px;
	box-sizing: border-box;
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
}

.patient-bottom-box .patient-button-box .van-button {
	width: 48%;
}

.unit {
	padding-top: 0.5rem;
	color: #999;
	font-size: 0.9em;
}
</style>
